module.exports = __webpack_public_path__ + "static/img/product_society_society_mddd.e2b9185.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product_society_society_mddd.png
// module id = vdkM
// module chunks = 0